import { call, all, put, takeEvery } from 'redux-saga/effects';
import URLs from '../../../constants/urls';
import {
  GET_QUESTION_BANK_REVIEW,
  GET_QUESTION_QBR,
  SET_QUESTION_REVIEW_BANK,
  SET_QUESTION_BANK,
  GET_CURRENT_AND_PREVIOUS,
  GET_QUESTION_DETAILS_PREVIEW,
  SET_QUESTION_PREVIEW,
  GET_QUESTION_PREVIEW
} from '../../actions/QuestionBankReview/actionTypes';
import { apiPython as api, apiRephrase } from '../../../service/api';

import {
  getQuestionBankReviewSuccessAction,
  getQuestionBankReviewFailureAction,
  getQuestionQBRSuccessAction,
  getQuestionQBRFailureAction,
  setQuestionReviewBankSuccessAction,
  setQuestionReviewBankFailureAction,
  setQuestionSuggestionSuccessAction,
  setQuestionSuggestionFailureAction,
  GetCurrentAndPreviousQuestionSuccessAction,
  GetCurrentAndPreviousQuestionFailureAction,
  GetQuestionDetailsForPreviewSuccessAction,
  GetQuestionDetailsForPreviewFailureAction,
  SaveQuestionReviewActionSuccessAction,
  SaveQuestionReviewActionFailureAction,
  EditQuestionReviewActionSuccessAction,
  EditQuestionReviewActionFailureAction
} from '../../features/questionBankReview/questionBankReviewSlice';

export function* getQuestioReviewSaga({ payload: data }) {
  try {
    const responseData = yield api.get(`${URLs.GET_QBRCYCLELIST}?SAMId=${data['SAMId']}&Type=${data['TYPE']}`);
    yield put(getQuestionBankReviewSuccessAction(responseData.data.data));
  } catch (error) {
    yield put(getQuestionBankReviewFailureAction(error));
  }
}

export function* getQuestioQBRSaga({ payload: data }) {
  try {
    const responseData = yield api.get(`${URLs.GET_QBRREVIEW_DATA}?loggedUserID=${data['loggedUserID']}`);
    yield put(getQuestionQBRSuccessAction(responseData.data.data));
  } catch (error) {
    yield put(getQuestionQBRFailureAction(error));
  }
}

export function* setQuestioQBRSaga({ payload: body }) {
  // const formData = new FormData();
  // formData.append("Skill_Id", body['Skill_Id']);
  // formData.append("Prompt", body['Prompt']);
  // formData.append("questionType", body['questionType']);
  // formData.append("Complexity", body['Complexity']);
  // formData.append("QuestionOptions", body['QuestionOptions']);
  // formData.append("questionId", body['questionId']);
  // formData.append("imageType", body['image']);
  try {
    const response = yield api.post(URLs.SET_SAVEQUESTION, body);
    yield put(setQuestionReviewBankSuccessAction(response.data.data));
  } catch (error) {
    yield put(setQuestionReviewBankFailureAction(error));
  }
}

export function* setQuestioSuggestionSaga({ payload: body }) {
  try {
    const response = yield apiRephrase.post('', { question: body.Question, type: 'Rew' });
    const suggestions = typeof response.data === 'string' ? response.data : JSON.stringify(response.data);
    yield put(setQuestionSuggestionSuccessAction(suggestions));
    
  } catch (error) {
    yield put(setQuestionSuggestionFailureAction(error));
  }
}

export function* setQuestionIndexSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.GET_CURRENT_AND_PREVIOUS_QUESTION, body);
    yield put(GetCurrentAndPreviousQuestionSuccessAction(response.data.data));
  } catch (error) {
    yield put(GetCurrentAndPreviousQuestionFailureAction(error));
  }
}

export function* setQuestionPreviewSaga({ payload: data }) {
  const rawId = data?.questionId ?? data?.QuestionId;
  const questionId = Number(rawId);
  if (!Number.isFinite(questionId) || questionId <= 0) {
    yield put(GetQuestionDetailsForPreviewFailureAction(new Error('Invalid questionId')));
    return;
  }
  try {
    const response = yield api.get(`${URLs.GET_QUESTION_DETAILS_PREVIEW}?questionId=${questionId}`);
    yield put(GetQuestionDetailsForPreviewSuccessAction(response.data.data));
  } catch (error) {
    yield put(GetQuestionDetailsForPreviewFailureAction(error));
  }
}


export function* setSaveQuestionReviewActionSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SAVE_QUESTION_REVIEW, body);
    yield put( SaveQuestionReviewActionSuccessAction(response.data.data));
  } catch (error) {
    yield put(SaveQuestionReviewActionFailureAction(error));
  }
}

export function* setEditQuestionReviewActionSaga({ payload: data }) {
  try {
    const response = yield api.get(`${URLs.GET_QUESTION_REVIEW}?id=${data['id']}`);
    yield put(EditQuestionReviewActionSuccessAction(response.data.data));
  } catch (error) {
    yield put(EditQuestionReviewActionFailureAction(error));
  }
}

export function* watchQuestionReview() {
  yield takeEvery(GET_QUESTION_BANK_REVIEW, getQuestioReviewSaga);
  yield takeEvery(GET_QUESTION_QBR, getQuestioQBRSaga);
  yield takeEvery(SET_QUESTION_REVIEW_BANK, setQuestioQBRSaga);
  yield takeEvery(SET_QUESTION_BANK, setQuestioSuggestionSaga);
  yield takeEvery(GET_CURRENT_AND_PREVIOUS, setQuestionIndexSaga);
  yield takeEvery(GET_QUESTION_DETAILS_PREVIEW, setQuestionPreviewSaga);
  yield takeEvery(SET_QUESTION_PREVIEW, setSaveQuestionReviewActionSaga);
  yield takeEvery(GET_QUESTION_PREVIEW, setEditQuestionReviewActionSaga);
}

export default function* questionBankReview() {
  yield all([watchQuestionReview()]);
}
